import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/Auth Slice/authSlice";
import labelsReducer from "../features/Labels Slice/labelsSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    label: labelsReducer,
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
